import { useToast } from "@/hooks/use-toast"
import { useToastKeyboardNavigation } from "@/hooks/useToastKeyboardNavigation"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"
import { ToastNavigator } from "@/components/ui/toast-navigator"

export function Toaster() {
  const { toasts, currentIndex, nextToast, previousToast, isPaused } = useToast()
  
  // Enable keyboard navigation
  useToastKeyboardNavigation()

  // Get the current toast to display
  const currentToast = toasts[currentIndex]

  if (!currentToast) {
    return (
      <ToastProvider>
        <ToastViewport />
      </ToastProvider>
    )
  }

  const { id, title, description, action, ...props } = currentToast

  return (
    <ToastProvider>
      <Toast key={id} {...props}>
        <ToastClose />
        <ToastNavigator
          currentIndex={currentIndex}
          totalToasts={toasts.length}
          onNext={nextToast}
          onPrevious={previousToast}
          isPaused={isPaused}
        >
          <div className="grid gap-1 w-full">
            {title && <ToastTitle>{title}</ToastTitle>}
            {description && (
              <ToastDescription>{description}</ToastDescription>
            )}
          </div>
          {action}
        </ToastNavigator>
      </Toast>
      <ToastViewport />
    </ToastProvider>
  )
}
